import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  p {
    font-size: 20px;
    line-height: 26px;
    margin-left: 19px;

    @media (max-width: 1024px) {
      margin-top: 24px;
      font-size: 14px;
      line-height: 18px;
      margin-left: 16px;
    }
  }

  img {
    margin-top: 6px;
    width: 200px;
    height: 200px;

    @media (max-width: 1024px) {
      margin-left: 16px;
    }
  }
`;

const MJackson = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <img src={require('assets/images/michael-jackson.jpg')} alt="" />
      <p>
        A graduate of Columbia University, Michael is an experienced product manager and the former
        regional head of delivery for global asset and wealth management organisations. He has years
        of experience delivering global projects aimed at improving operational efficiency and
        service/product delivery.
      </p>
    </Wrapper>
  );
};

export default MJackson;
